"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerService = {
  id: "customerService",
  title: {
    en: "Customer Services",
    de: "Kundendienst"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q1: Will my account be deleted if I do not use it for a long time?"), /*#__PURE__*/_react.default.createElement("p", null, "A: For your convenience and better service environment, Ferentus deletes accounts and character information as followings."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Characters of level 10 or lower who have not logged on for the past 90 days."), /*#__PURE__*/_react.default.createElement("li", null, "Accounts that have no character of level 10 or higher for past 90 days."), /*#__PURE__*/_react.default.createElement("li", null, "All accounts that were not logged in for 1 year."))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q2: How do I report if my account was hacked?"), /*#__PURE__*/_react.default.createElement("p", null, "A: [To be concluded later.]"), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q3: I made a hacking\\/cheat report and want to cancel it. What should I do?"), /*#__PURE__*/_react.default.createElement("p", null, "A: If you cancel your report on hacking/cheat, we will regard it as a false report and you will receive a warning. If the same incident persists, your account can be blocked permanently, so be careful when you make reports."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q4: When will my items be recovered after the report?"), /*#__PURE__*/_react.default.createElement("p", null, "A: Our customer service center will recover your lost items within 15 days of your report. (There can be a loss of EXP/level/items)"), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q5: I think my password has been changed by hacking."), /*#__PURE__*/_react.default.createElement("p", null, "A: [To be concluded later.]"))
  }
};
var _default = customerService;
exports.default = _default;